import React, { useEffect } from "react";
import Breadcrumbs from "../../../components/Breadcrumbs";
import Header from "../../layout/Header";
import Sidebar from "../../layout/Sidebar";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { closeAttendanceModal, fetchAttendance, openAttendanceModal } from "./store/attendanceSlice";
import AttendanceTable from "./AttendanceTable";
import AddAttendance from "./AddAttendance";

const Attendance = () => {
  const dispatch = useDispatch();
  const {
    data = [],
    loading = false,
    isModalOpen = false,
  } = useSelector((state) => state.attendanceData || {});

  useEffect(() => {
    dispatch(fetchAttendance());
  }, [dispatch]);

  return (
    <div className="main-wrapper">
      <Header />
      <Sidebar />
      <div className="page-wrapper">
        <div className="content container-fluid">
          <Breadcrumbs
            maintitle="Attendance "
            title="Dashboard"
            subtitle="Attendance"
            name="Import Attendance"
            onAddClick={() => dispatch(openAttendanceModal())}
          />

          <AttendanceTable data={data} loading={loading} />

          <AddAttendance
            show={isModalOpen}
            onClose={() => dispatch(closeAttendanceModal())}
          />
        </div>
      </div>
    </div>
  );
};



export default Attendance;
